import { render, staticRenderFns } from "./ModalAdicionarItem.vue?vue&type=template&id=66ae4370&scoped=true"
import script from "./ModalAdicionarItem.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarItem.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarItem.vue?vue&type=style&index=0&id=66ae4370&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ae4370",
  null
  
)

export default component.exports